<template>
  <div>
    <div id="container"></div>
  </div>
</template>

<script>
import {TMap} from "utils/TMap";

export default {
  name: 'tmap',
  data() {
    return {
      TMap:null,
      point:'',
      markersArray:[],
      searchService:'',
    }
  },
  props:{
    // pointData: {
    //   type:[Number, String]
    // },
    complateData: {
      type: String
    },
    search:{
      type: String
    }
  },
  mounted () {
    this.init();
  },
  watch:{
    complateData (val) {
      if (val){
        this.complateData = val;
        this.init();
      }
    },
    search (val) {
      // console.log(val)
      this.searchKeyword(val)
    }
  },
  methods:{
    init () {
     const _this = this;

     // TMap('W4CBZ-ATW3Q-25E56-GTYUQ-3PAP2-DWFG6').then(qq => {
      TMap('532BZ-OAKKJ-KJWFH-FIPEM-M6YEJ-3CBPP').then(qq => {
       const center = new qq.maps.LatLng(39.916527,116.397128); // 默认地址

       //地址和经纬度之间进行转换服务
       const geocoder = new qq.maps.Geocoder();
       const citylocation = new qq.maps.CityService();

       let map = new qq.maps.Map(document.getElementById("container"), {
         // 地图的中心地理坐标。
         center:  center,  //  默认北京天安门广场
         zoom: 15,
       });
       _this.TMap = map;

       //创建一个Marker
       var marker
       if (_this.complateData) {
         let geocoder;
         var latlngStr = _this.complateData.split(",",2);
         var lng = parseFloat(latlngStr[0]);
         var lat = parseFloat(latlngStr[1]);
         var latLng = new qq.maps.LatLng(lat, lng);

         geocoder = new qq.maps.Geocoder({
           //设置服务请求成功的回调函数
           complete: function(result) {
             map.setCenter(result.detail.location);
             console.log(result.detail.location)
             _this.addMarker(result.detail.location)
             qq.maps.event.addListener(_this.markersArray[0], 'click', function() {
               _this.$Message.success({   // 提示用户默认地址
                 content:"该坐标地址为 " +  result.detail.address,
                 duration: 2
               })
             });
           },
           //若服务请求失败，则运行以下函数
           error: function() {
             // alert("出错啦，请获输入正确的地址");
           }
         });
         // geocoder.getLocation(_this.complateData); // 传入是地址解析
         geocoder.getAddress(latLng );  // 传入经纬度解析

        } else {    //  当用户第一次打开地图时跟据用户的ID来定位
         //调用searchLocalCity();方法    根据用户IP查询城市信息。
         console.log(1)
         citylocation.searchLocalCity();

         citylocation.setComplete(function(result){
           map.setCenter(result.detail.latLng); // 初始化地图中心
           _this.$Message.info({   // 提示用户默认地址
             content:"您所在的城市地址为 " +  result.detail.name,
             duration: 2
           })
         });
       }

       //添加监听事件
       qq.maps.event.addListener(map, 'click', function(event) {
         // 删除检索到其位置
         if (_this.markersArray.length > 0) {
           _this.clearOverlays();
         }
         // 当点击一地图时首先删除上一个标注图标
         // 用户点击时添加标注图标
         _this.addMarker(event.latLng)
         const location = {
           complate:'',
           point:''
         };
         //对指定经纬度进行解析
         geocoder.getAddress(event.latLng);
         //设置服务请求成功的回调函数
         geocoder.setComplete(function(result) {
           let addr = result.detail.addressComponents;
           // let address = addr.province + " " + addr.city + " " + addr.district + " " + addr.street + " " + addr.streetNumber + " " + addr.town + " " + addr.village;
           let address = addr.province + " " + addr.city + " " + addr.district;
           location.point = event.latLng;
           location.complate = address;
           _this.$emit('point',location);
         });

         // 将逆解析后的经纬度和中文地址发送到父组件中
       });

       _this.searchService = new qq.maps.SearchService({
         complete : function(results){
           var pois = results.detail.pois;
            if (pois) {
              for(var i = 0,l = pois.length;i < 1; i++){
                var poi = pois[i];
                // _this.clearOverlays()
                let point = {}
                point.point = poi.latLng;
                point.complate = `${poi.address.substring(0,3)} ${poi.address.substring(3,6)} ${poi.address.substring(6,9)}`
                _this.$emit('point', point);
                  var geocoder,map;
                  map = new qq.maps.Map(document.getElementById('container'),{
                      center: center,
                      zoom: 15
                  });
                  //调用地址解析类
                  geocoder = new qq.maps.Geocoder({
                      complete : function(result){
                          map.setCenter(result.detail.location);
                          var marker = new qq.maps.Marker({
                              map:map,
                              position: result.detail.location
                          });
                          _this.markersArray.push(marker);
                      }
                  });
                  geocoder.getLocation(point.complate)
                // _this.addMarker(poi.latLng);

              }
            //添加监听事件
            qq.maps.event.addListener(map, 'click', function(event) {
                if (_this.markersArray) {
                    for (let i in _this.markersArray) {
                        _this.markersArray[i].setMap(null);
                    }
                    _this.markersArray.length = 0;
                }
                var marker=new qq.maps.Marker({
                    position:event.latLng,
                    map:map
                });
                // 删除检索到其位置

                _this.markersArray.push(marker);
                // 当点击一地图时首先删除上一个标注图标
                // 用户点击时添加标注图标
                // _this.addMarker(event.latLng)
                const location = {
                    complate:'',
                    point:''
                };
                //对指定经纬度进行解析
                geocoder.getAddress(event.latLng);
                //设置服务请求成功的回调函数
                geocoder.setComplete(function(result) {
                    let addr = result.detail.addressComponents;
                    // let address = addr.province + " " + addr.city + " " + addr.district + " " + addr.street + " " + addr.streetNumber + " " + addr.town + " " + addr.village;
                    let address = addr.province + " " + addr.city + " " + addr.district;
                    location.point = event.latLng;
                    location.complate = address;
                    _this.$emit('point',location);
                });

                // 将逆解析后的经纬度和中文地址发送到父组件中
            });
            }
         }
       });

      //调用地址解析类
       _this.getLocation  = new qq.maps.Geocoder({
         complete : function(result){
           map.setCenter(result.detail.location);
           var marker = new qq.maps.Marker({
             map:map,
             position: result.detail.location
           });
           _this.markersArray.push(marker);
           let point = {}
           point.point = result.detail.location;
           var addressComponents = result.detail.addressComponents;
           point.complate = `${addressComponents.province} ${addressComponents.city} ${addressComponents.district}`
           _this.$emit('point', point);
           //添加监听事件
           qq.maps.event.addListener(map, 'click', function(event) {
             if (_this.markersArray) {
               for (let i in _this.markersArray) {
                 _this.markersArray[i].setMap(null);
               }
               _this.markersArray.length = 0;
             }
             var marker=new qq.maps.Marker({
               position:event.latLng,
               map:map
             });
             // 删除检索到其位置

             _this.markersArray.push(marker);
             // 当点击一地图时首先删除上一个标注图标
             // 用户点击时添加标注图标
             // _this.addMarker(event.latLng)
             const location = {
               complate:'',
               point:''
             };
             //对指定经纬度进行解析
             geocoder.getAddress(event.latLng);
             //设置服务请求成功的回调函数
             geocoder.setComplete(function(result) {
               let addr = result.detail.addressComponents;
               // let address = addr.province + " " + addr.city + " " + addr.district + " " + addr.street + " " + addr.streetNumber + " " + addr.town + " " + addr.village;
               let address = addr.province + " " + addr.city + " " + addr.district;
               location.point = event.latLng;
               location.complate = address;
               _this.$emit('point',location);
             });

             // 将逆解析后的经纬度和中文地址发送到父组件中
           });
         }
       });
     });
     },
    searchKeyword (search) {
      this.clearOverlays(this.markers);
      // this.searchService.search(search);
      this.getLocation.getLocation(search);
    },
    addMarker(location) { // 添加标记
      var marker = new qq.maps.Marker({
        position: location,
        map: this.TMap
      });
      this.markersArray.push(marker);
    },
    clearOverlays () { // 删除覆盖物
      if (this.markersArray) {
        for (let i in this.markersArray) {
          this.markersArray[i].setMap(null);
        }
        this.markersArray.length = 0;
      }
    }
  },
}
</script>

<style scoped>
  #container {
    min-width:100%;
    min-height:100%;
  }
</style>
